<template>
    <div class="contact-page body-box">
        <div class="hero-header">
            <h3 class="title-with-dot">{{ headerTitle }}</h3>
            <router-link to="/contact" class="status-for-work">{{ status }}</router-link>
        </div>

		<div class="contact-content-body">
			<div class="contact-content-body-inner">
					
				<h1>{{ sectionTitle }}</h1>
				<p>{{ sectionDescription }}</p>

            </div>

            <contact-form />

            <ohilo-footer />

        </div>

    </div>
</template>

<script>
import ContactForm from "@/components/modules/ContactForm.vue";
import OhiloFooter from '@/components/common/OhiloFooter.vue';


export default {
    name: 'ContactView',
    components: {
        ContactForm,
        OhiloFooter
    },
    data() {
        return {
            headerTitle: 'Hire Me',
            status: 'Available for work',
            sectionTitle: 'Design Inquiry',
            sectionDescription: 'Got an idea and need design help? Reach out now'
        }
    }
}
</script>